
<script>
import New from './New10'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
